/** Ekonomia — stałe integer zł. Zero floatów. */
import { z } from 'zod';

export const PET_SMILE_ZL = 5 as const;
export const MINIGAME_FINISH_BASE_ZL = 5 as const;
export const MINIGAME_GOOD_ZL = 10 as const; // łącznie przy „dobrej grze"
export const EXPLORER_BONUS_ZL = 50 as const;
export const PET_COOLDOWN_SEC = 60 as const;
export const PET_DAILY_CAP = 40 as const;
/** Nagroda za ukończoną misję (PLAN-V2 §7.2 / §9). */
export const QUEST_REWARD_ZL = 8 as const;
/** Max wypłat misji na dobę UTC (PLAN-V2 §7.2). */
export const QUEST_DAILY_CAP = 5 as const;
/** Saldo startowe każdego nowego pieska (WAVE3-G4). */
export const STARTING_BALANCE_ZL = 500 as const;
/** Codzienna nagroda za logowanie (WAVE5-W1) — raz na dobę UTC. */
export const DAILY_REWARD_ZL = 50 as const;

export const FORTUNE_GRANTS = {
  bogaty: 200,
  normalny: 100,
  biedny: 30,
} as const;

export type FortuneTier = keyof typeof FORTUNE_GRANTS;

/** TODO-DECISION(user): skala „15,9" z BRIEF — placeholder 159 zł. */
export const GARDEN_PRICE_ZL = 159 as const;

export const ITEM_PRICE_RANGE = { min: 10, max: 40 } as const;
export const BLOCK_PRICE_RANGE = { min: 2, max: 12 } as const;

export type TransactionType =
  | 'PET_SMILE'
  | 'MINIGAME_REWARD'
  | 'EXPLORER_BONUS'
  | 'FORTUNE_GRANT'
  | 'STARTING_GRANT'
  | 'PURCHASE'
  | 'GARDEN_UNLOCK'
  | 'PROFILE_RESET'
  | 'QUEST_REWARD'
  | 'DAILY_REWARD';

/** GET /api/economy/daily/status */
export const DailyStatusResponseSchema = z.object({
  eligible: z.boolean(),
  nextResetUtc: z.string().optional(),
  amountZl: z.number().int().positive(),
});
export type DailyStatusResponse = z.infer<typeof DailyStatusResponseSchema>;

/** POST /api/economy/daily/claim */
export const DailyClaimResponseSchema = z.object({
  claimed: z.boolean(),
  alreadyClaimed: z.boolean().optional(),
  amountZl: z.number().int().nonnegative().optional(),
  balanceZl: z.number().int().nonnegative(),
});
export type DailyClaimResponse = z.infer<typeof DailyClaimResponseSchema>;
